module.exports = __webpack_public_path__ + "img/pic-LindsayZhao.b29d1e08.png";